import { countriesOptions } from '@/constants/countries';
import api from '@/modules/api';

export const getCountryDetails = (code: string) =>
    countriesOptions.find((item) => item.value.toLowerCase() === code.toLowerCase());

export const resolveUserCountry = async () => {
    try {
        const { country } = await api.getClientIP();
        if (country) return getCountryDetails(country.isoAlpha2);
        return null;
    } catch (error) {
        console.log(`Something went wrong while user country update.`);
        return null;
    }
};
